import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import 'bootstrap-icons/font/bootstrap-icons.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js' // 這一行是關鍵！
//import 'bootstrap'
import i18n from './i18n'

createApp(App).use(router).use(i18n).mount('#app')